import { createSlice } from "@reduxjs/toolkit";

import {
  GalleryDataInitialStatus,
  GetGalleryData,
} from "../../../../types/webCms/gallery";
import { getAllGalleryAsync, updateGalleryAsync } from "./galleryApi";

const initialState: GalleryDataInitialStatus<GetGalleryData> = {
  loading: false,
  manageLoading: false,
  galleryDataList: [],
  countGalleryData: 0,
};

const galleryDataSlice = createSlice({
  name: "admin-gallery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllGalleryAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllGalleryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.galleryDataList = action.payload.data;
        state.countGalleryData = action.payload.length;
      })
      .addCase(getAllGalleryAsync.rejected, (state) => {
        state.loading = false;
        state.galleryDataList = [];
        state.countGalleryData = 0;
      });

    // update
    builder
      .addCase(updateGalleryAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateGalleryAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateGalleryAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default galleryDataSlice;
